export enum AddProductsToReservationPanelDataTestIds {
    claimProductsCheckbox = 'pcl-claim-products-checkbox',
}
